import React, { useState } from 'react';
import { 
  FiTrendingUp, 
  FiUsers, 
  FiSettings,
  FiEye,
  FiZap,
  FiTarget,
  FiGlobe,
  FiShare2,
  FiShoppingCart
} from 'react-icons/fi';

import {
  MarketplaceContainer,
  MarketplaceTitle,
  MarketplaceSubtitle,
  ButtonsOuterContainer,
  MarketplaceButtonContainer,
  MarketplaceButton,
  IconWrapper,
  MarketplaceFeaturesGrid,
  MarketplaceFeatureCard,
  FeatureIcon,
  FeatureText,
  CardBottomLine
} from './styles';

const MarketplaceSection = () => {
  const [activeButton, setActiveButton] = useState(0);

  const buttons = [
    { id: 0, label: 'Ventas sin anuncios', icon: <FiTrendingUp /> },
    { id: 1, label: 'Exposición inmediata', icon: <FiUsers /> },
    { id: 2, label: 'Autoridad validada', icon: <FiSettings /> }
  ];

  const features = [
    {
      icon: <FiEye />,
      text: 'Tus productos se muestran incluso cuando no estás conectado. Más visibilidad, más ventas.'
    },
    {
      icon: <FiZap />,
      text: 'Nuestro modelo elimina el miedo, la desconfianza y la falta de tarjeta.'
    },
    {
      icon: <FiTarget />,
      text: 'Copia, pega y lanza. Sin plataformas intermedias, sin complicaciones.'
    },
    {
      icon: <FiGlobe />,
      text: 'Sigue vendiendo desde tu página, solo añadiendo un botón extra "Pagar Contraentrega".'
    },
    {
      icon: <FiShare2 />,
      text: 'Apareces gratis en nuestro ecosistema y aprovechas tráfico calificado.'
    },
    {
      icon: <FiShoppingCart />,
      text: 'Personas listas para pagar en efectivo al recibir. Sin barreras, sin tarjetas.'
    }
  ];

  return (
    <MarketplaceContainer>
      <MarketplaceTitle>Presencia gratuita en el marketplace de Floqss</MarketplaceTitle>
      <MarketplaceSubtitle>
        Al publicar tu producto en Floqss, también pasa a formar parte de nuestro marketplace, donde activa ventas orgánicas sin gastar un peso en publicidad.
      </MarketplaceSubtitle>

      <ButtonsOuterContainer>
        <MarketplaceButtonContainer>
          {buttons.map((button, index) => (
            <MarketplaceButton
              key={button.id}
              isActive={activeButton === index}
              onClick={() => setActiveButton(index)}
            >
              <IconWrapper isActive={activeButton === index}>{button.icon}</IconWrapper>
              {button.label}
            </MarketplaceButton>
          ))}
        </MarketplaceButtonContainer>
      </ButtonsOuterContainer>

      <MarketplaceFeaturesGrid>
        {features.map((feature, index) => (
          <MarketplaceFeatureCard key={index}>
            <FeatureIcon>{feature.icon}</FeatureIcon>
            <FeatureText>{feature.text}</FeatureText>
            <CardBottomLine />
          </MarketplaceFeatureCard>
        ))}
      </MarketplaceFeaturesGrid>
    </MarketplaceContainer>
  );
};

export default MarketplaceSection;